import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMFormModal, IMSelect } from '@insurancemenu/imenu-components-lib';
import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { AgentOfRecordFormFields } from 'store/modules/group/ui-stores/agentOfRecordModalDelegate';

const AGENT_OF_RECORD_FORM_ID = 'agent-of-record-form';

interface Props {
  show: boolean;
  onClose: () => void;
  formController: FormController<AgentOfRecordFormFields>;
  agentOptions: OptionType[];
}

const AgentOfRecordModal: React.FC<Props> = observer(({ show, onClose, formController, agentOptions }) => {
  return (
    <IMFormModal
      formId={AGENT_OF_RECORD_FORM_ID}
      title="Agent of Record"
      subtitle="Update the agent of record for this group"
      show={show}
      onClose={onClose}
      formController={formController}
      closeButtonText="Cancel"
      submitButtonText="Save"
      formContent={
        <IMSelect
          label="Agent of Record"
          name="agentOfRecord"
          placeholder="Select an agent"
          options={agentOptions}
          size="full"
        />
      }
    />
  );
});

export default AgentOfRecordModal;
